import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

// register $http with the PHP Backend
Vue.use(VueAxios, axios.create({
  baseURL: process.env.VUE_APP_PHP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    //'Authorization': 'Bearer ' + localStorage.token
  }
}))

// Add the Ruby Backend at $newpetehealthapi
Vue.prototype.$newpetehealthapi = axios.create({
  baseURL: process.env.VUE_APP_RUBY_URL + '/api',
})

Vue.prototype.$newpetehealthapi.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('authtoken')
    if (token) {
      config.headers['Authorization'] = `Basic ${ token }`
    }
    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)

Vue.prototype.$newpetehealthapi.interceptors.response.use(function (response) {
  return response;
}, function (error) {
 /*Remove later*/
  // location.href = '#/pages/login';
  /*Remove later*/
  if (error.response.status === 401) {
    // location.href = '#/pages/login';
  }
  return Promise.reject(error);
});
